import { forwardRef } from "react";
import { Button as ChakraButton } from "@chakra-ui/react-real";

// GLOBAL Hakina "Soft Modern" button — every <Button> in the app (and any
// future one) resolves here via the webpack alias on "@chakra-ui/react".
// Per-instance props are spread LAST, so intentional one-offs still win.
const VARIANTS = {
  // Primary — creates / adds / advances / saves / submits.
  solid: {
    bg: "#25A1B0",
    color: "#FFFFFF",
    boxShadow: "0 2px 5px rgba(37,161,176,0.28)",
    _hover: { bg: "#0E7C8B" },
  },
  // Secondary — supporting actions (Cancel, Back, Unpublish).
  outline: {
    bg: "#FFFFFF",
    color: "#0E7C8B",
    borderWidth: "1.5px",
    borderStyle: "solid",
    borderColor: "#BFE3E8",
    _hover: { bg: "#E6F5F7" },
  },
  // Ghost / text — low-priority actions.
  ghost: {
    bg: "transparent",
    color: "#0E7C8B",
    _hover: { bg: "#E6F5F7" },
  },
  // Danger — destructive primaries (Delete).
  danger: {
    bg: "#D9482B",
    color: "#FFFFFF",
    boxShadow: "0 2px 5px rgba(217,72,43,0.28)",
    _hover: { bg: "#B93A21" },
  },
};

const SIZE_SMALL = { minH: "40px", px: "20px", fontSize: "13.5px" };
const SIZE_REGULAR = { minH: "48px", px: "28px", fontSize: "15px", minW: "120px" };
const FOCUS_RING = { outline: "none", boxShadow: "0 0 0 3px #BFE3E8" };
const DISABLED_STYLE = { opacity: 0.45, cursor: "not-allowed", boxShadow: "none" };

export const Button = forwardRef(function HakinaButton(
  { variant = "solid", size = "md", ...props },
  ref
) {
  const v = VARIANTS[variant] || VARIANTS.solid;
  const s = size === "xs" || size === "sm" ? SIZE_SMALL : SIZE_REGULAR;
  return (
    <ChakraButton
      ref={ref}
      variant={variant === "danger" ? "solid" : variant}
      size={size}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      gap="8px"
      whiteSpace="nowrap"
      flexShrink={0}
      fontFamily="'Montserrat', sans-serif"
      fontWeight="600"
      lineHeight="1"
      borderRadius="11px"
      h="auto"
      transition="background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease"
      _focusVisible={FOCUS_RING}
      _disabled={DISABLED_STYLE}
      {...s}
      {...v}
      {...props}
    />
  );
});
